import React from 'react';
import { Instagram } from 'lucide-react';
import { images, companyInfo } from '../data/mockData';

const Footer = ({ content }) => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="container mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src={images.logo}
              alt="Lamazi Group"
              className="h-10 w-auto object-contain mb-4"
            />
            <p className="text-slate-400 leading-relaxed max-w-md">
              {content.footer.tagline}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {content.footer.links.about}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('products')}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {content.footer.links.products}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('packaging')}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {content.footer.links.packaging}
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('logistics')}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  {content.footer.links.logistics}
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">{content.footer.links.contact}</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  Request a Quote
                </button>
              </li>
              <li>
                <a
                  href={`https://wa.me/${companyInfo.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  WhatsApp
                </a>
              </li>
              <li>
                <a
                  href={`https://instagram.com/${companyInfo.instagram}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center space-x-2 text-slate-400 hover:text-pink-400 transition-colors"
                >
                  <Instagram className="w-4 h-4" />
                  <span>Instagram</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800">
          <p className="text-center text-slate-500 text-sm">
            {content.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
